var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.height)?_c('div',{staticClass:"wrap",style:(_vm.style)},[_c('img',{staticClass:"placeholder",attrs:{"src":require("../imgs/hu.png")}})]):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b79480b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./lib/components/lazy.vue
// module id = xQDi
// module chunks = 1